<template>
  <div>
    <CCard class="shadow-sm rounded-3 bg-white mt-3">
      <CCardHeader style="background-color: #145654" class="border-bottom">
        <h4 class="card-title mb-0 text-white">
          <CIcon name="cil-book" size="xl" class="mr-2"/> {{ $t('userManual.title') }}
        </h4>
      </CCardHeader>
      <CCardBody class="p-4">
        
        <CTabs variant="pills" :active-tab="0">
          <CTab :title="$t('userManual.tabUser')" v-if="userRole === 'admin' || userRole === 'user'">
            <div class="mt-4">
              <h5 class="font-weight-bold text-primary mb-4">{{ $t('userManual.userHeading') }}</h5>
              <div class="flowchart-container">
                <div class="flow-step">
                  <div class="flow-icon bg-info"><CIcon name="cil-pencil" size="lg" class="text-white"/></div>
                  <div class="flow-title">{{ $t('userManual.u1t') }}</div>
                  <div class="flow-desc">{{ $t('userManual.u1d') }}</div>
                </div>
                <div class="flow-arrow"><CIcon name="cil-arrow-right" size="xl"/></div>
                <div class="flow-step">
                  <div class="flow-icon bg-secondary"><CIcon name="cil-clock" size="lg" class="text-white"/></div>
                  <div class="flow-title">{{ $t('userManual.u2t') }}</div>
                  <div class="flow-desc">{{ $t('userManual.u2d') }}</div>
                </div>
                <div class="flow-arrow"><CIcon name="cil-arrow-right" size="xl"/></div>
                <div class="flow-step">
                  <div class="flow-icon bg-warning text-dark"><CIcon name="cil-wrench" size="lg"/></div>
                  <div class="flow-title">{{ $t('userManual.u3t') }}</div>
                  <div class="flow-desc">{{ $t('userManual.u3d') }}</div>
                </div>
                <div class="flow-arrow"><CIcon name="cil-arrow-right" size="xl"/></div>
                <div class="flow-step">
                  <div class="flow-icon bg-success"><CIcon name="cil-star" size="lg" class="text-white"/></div>
                  <div class="flow-title">{{ $t('userManual.u4t') }}</div>
                  <div class="flow-desc">{{ $t('userManual.u4d') }}</div>
                </div>
              </div>
            </div>
          </CTab>

          <CTab :title="$t('userManual.tabSupervisor')" v-if="userRole === 'admin' || userRole === 'supervisor'">
            <div class="mt-4">
              <h5 class="font-weight-bold text-primary mb-4">{{ $t('userManual.supHeading') }}</h5>
              <div class="flowchart-container">
                <div class="flow-step">
                  <div class="flow-icon bg-warning text-dark"><CIcon name="cil-bell" size="lg"/></div>
                  <div class="flow-title">{{ $t('userManual.s1t') }}</div>
                  <div class="flow-desc">{{ $t('userManual.s1d') }}</div>
                </div>
                <div class="flow-arrow"><CIcon name="cil-arrow-right" size="xl"/></div>
                <div class="flow-step">
                  <div class="flow-icon bg-info"><CIcon name="cil-user-follow" size="lg" class="text-white"/></div>
                  <div class="flow-title">{{ $t('userManual.s2t') }}</div>
                  <div class="flow-desc">{{ $t('userManual.s2d') }}</div>
                </div>
                <div class="flow-arrow"><CIcon name="cil-arrow-right" size="xl"/></div>
                <div class="flow-step">
                  <div class="flow-icon bg-secondary"><CIcon name="cil-search" size="lg" class="text-white"/></div>
                  <div class="flow-title">{{ $t('userManual.s3t') }}</div>
                  <div class="flow-desc">{{ $t('userManual.s3d') }}</div>
                </div>
                <div class="flow-arrow"><CIcon name="cil-arrow-right" size="xl"/></div>
                <div class="flow-step">
                  <div class="flow-icon bg-success"><CIcon name="cil-check" size="lg" class="text-white"/></div>
                  <div class="flow-title">{{ $t('userManual.s4t') }}</div>
                  <div class="flow-desc">{{ $t('userManual.s4d') }}</div>
                </div>
              </div>
            </div>
          </CTab>

          <CTab :title="$t('userManual.tabTech')" v-if="userRole === 'admin' || userRole === 'technician'">
            <div class="mt-4">
              <h5 class="font-weight-bold text-primary mb-4">{{ $t('userManual.techHeading') }}</h5>
              <div class="flowchart-container">
                <div class="flow-step">
                  <div class="flow-icon bg-warning text-dark"><CIcon name="cil-task" size="lg"/></div>
                  <div class="flow-title">{{ $t('userManual.t1t') }}</div>
                  <div class="flow-desc">{{ $t('userManual.t1d') }}</div>
                </div>
                <div class="flow-arrow"><CIcon name="cil-arrow-right" size="xl"/></div>
                <div class="flow-step">
                  <div class="flow-icon bg-info"><CIcon name="cil-camera" size="lg" class="text-white"/></div>
                  <div class="flow-title">{{ $t('userManual.t2t') }}</div>
                  <div class="flow-desc">{{ $t('userManual.t2d') }}</div>
                </div>
                <div class="flow-arrow"><CIcon name="cil-arrow-right" size="xl"/></div>
                <div class="flow-step">
                  <div class="flow-icon bg-primary"><CIcon name="cil-wrench" size="lg" class="text-white"/></div>
                  <div class="flow-title">{{ $t('userManual.t3t') }}</div>
                  <div class="flow-desc">{{ $t('userManual.t3d') }}</div>
                </div>
                <div class="flow-arrow"><CIcon name="cil-arrow-right" size="xl"/></div>
                <div class="flow-step">
                  <div class="flow-icon bg-success"><CIcon name="cil-notes" size="lg" class="text-white"/></div>
                  <div class="flow-title">{{ $t('userManual.t4t') }}</div>
                  <div class="flow-desc">{{ $t('userManual.t4d') }}</div>
                </div>
              </div>
            </div>
          </CTab>

          <CTab :title="$t('userManual.tabAdmin')" v-if="userRole === 'admin'">
            <div class="mt-4">
              <h5 class="font-weight-bold text-primary mb-4">{{ $t('userManual.adminHeading') }}</h5>
              <div class="flowchart-container">
                <div class="flow-step">
                  <div class="flow-icon bg-secondary"><CIcon name="cil-speedometer" size="lg" class="text-white"/></div>
                  <div class="flow-title">{{ $t('userManual.a1t') }}</div>
                  <div class="flow-desc">{{ $t('userManual.a1d') }}</div>
                </div>
                <div class="flow-arrow"><CIcon name="cil-arrow-right" size="xl"/></div>
                <div class="flow-step">
                  <div class="flow-icon bg-warning text-dark"><CIcon name="cil-tags" size="lg"/></div>
                  <div class="flow-title">{{ $t('userManual.a2t') }}</div>
                  <div class="flow-desc">{{ $t('userManual.a2d') }}</div>
                </div>
                <div class="flow-arrow"><CIcon name="cil-arrow-right" size="xl"/></div>
                <div class="flow-step">
                  <div class="flow-icon bg-info"><CIcon name="cil-people" size="lg" class="text-white"/></div>
                  <div class="flow-title">{{ $t('userManual.a3t') }}</div>
                  <div class="flow-desc">{{ $t('userManual.a3d') }}</div>
                </div>
                <div class="flow-arrow"><CIcon name="cil-arrow-right" size="xl"/></div>
                <div class="flow-step">
                  <div class="flow-icon bg-primary"><CIcon name="cil-briefcase" size="lg" class="text-white"/></div>
                  <div class="flow-title">{{ $t('userManual.a4t') }}</div>
                  <div class="flow-desc">{{ $t('userManual.a4d') }}</div>
                </div>
              </div>
            </div>
          </CTab>
        </CTabs>

      </CCardBody>
    </CCard>
  </div>
</template>

<script>
export default {
  name: "UserManual",
  data() {
    return {
      userRole: "user"
    };
  },
  mounted() {
    const userStored = localStorage.getItem("user");
    if (userStored) {
      try {
        const parsed = JSON.parse(userStored);
        if (parsed && parsed.role) {
          this.userRole = parsed.role;
        }
      } catch (e) {
        console.error("Error parsing user role", e);
      }
    }
  }
};
</script>

<style scoped>
.flowchart-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 15px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 12px;
  border: 1px dashed #ced4da;
}

.flow-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 220px;
  padding: 20px 10px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.05);
  border: 1px solid #e9ecef;
  transition: transform 0.2s;
  min-height: 250px;
}

.flow-step:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.1);
}

.flow-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}

.flow-title {
  font-weight: 700;
  font-size: 1rem;
  margin-bottom: 10px;
  color: #333;
}

.flow-desc {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.5;
}

.flow-arrow {
  color: #adb5bd;
  display: flex;
  align-items: center;
}

@media (max-width: 992px) {
  .flow-arrow {
    transform: rotate(90deg);
    margin: 10px 0;
  }
  .flowchart-container {
    flex-direction: column;
  }
}
</style>
